import { AuthRequiredToolName } from './authRequiredToolContract';
import { CommonToolNames } from './commonToolContract';
import { DocumentSearchToolName } from './documentSearchContract';
import { GroupClassToolName } from './groupClassToolContract';
import { MembershipToolName } from './membershipToolContract';

export * from './authRequiredToolContract';
export * from './documentSearchContract';
export * from './commonToolContract';
export * from './membershipToolContract';
export * from './groupClassToolContract';

export const ToolNames = {
  ...CommonToolNames,
  AuthRequired: AuthRequiredToolName,
  DocumentSearch: DocumentSearchToolName,
  Membership: MembershipToolName,
  GroupClass: GroupClassToolName,
} as const;

export type ToolName = (typeof ToolNames)[keyof typeof ToolNames];
